export enum EnquiryFormsPermissions {
  VIEW_ENQUIRY_FORMS = 'enquiryForms.viewEnquiryForms',
  MANAGE_ENQUIRY_FORMS = 'enquiryForms.manageEnquiryForms',
}
